export default __webpack_public_path__ + "images/logo-pyrotenax.svg?cd5c6fffc6f649e4cb4bf70e5e2c352e";